import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shadcnComponents/ui/card";
import type { CreditSummary } from "../paymentHistoryLib/paymentHistoryTypes";

import { ToolTipInfo } from "../../PromoteAd/Components/Components";

interface CreditSummaryProps {
  summaries: CreditSummary[];
}

export function CreditSummary({ summaries }: CreditSummaryProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {summaries.map((summary) => (
        <Card key={summary.type} className="overflow-hidden">
          <CardHeader className="bg-primary/10">
            <CardTitle className="flex items-center justify-between">
              {summary.type}
              <ToolTipInfo Content={summary?.info} />
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium">Available:</span>
              <span className="text-lg font-bold text-green-600">
                {summary.available}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium">Used:</span>
              <span className="text-lg font-bold text-blue-600">
                {summary.used}
              </span>
            </div>
            <div className="mt-4 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-primary"
                style={{
                  width: `${
                    (summary.used / (summary.available + summary.used)) * 100
                  }%`,
                }}
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
